/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { Stream } from '../stream.schema';

export const IncidentRecordFileContentDto = zod.object({
  "content": zod.lazy(() => Stream).optional(),
  "fileName": zod.string().optional(),
  "contentType": zod.string().optional()
});

export type IncidentRecordFileContentDto = zod.input<typeof IncidentRecordFileContentDto>;
export type IncidentRecordFileContentDtoOutput = zod.output<typeof IncidentRecordFileContentDto>;
